import PickerView from './PickerView';
export default PickerView;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/picker-view/index.js
// module id = null
// module chunks = 